// src/context/AdminRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // 1. Wait while checking credentials
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Verifying admin permissions...</p>
      </div>
    );
  }

  // 2. Resolve the role state value or read from LocalStorage
  const directRoleFallback = user?.role || localStorage.getItem('role');

  // ⭐ MATCHING BACKEND VALUE: Changed from 'ADMIN' to 'ROLE_ADMIN'
  if (directRoleFallback === 'ROLE_ADMIN') {
    return children;
  }

  // 3. Denied
  console.warn("Access denied to admin endpoint. Role mismatch.");
  return <Navigate to="/login" replace />;
};

export default AdminRoute;